import { render, staticRenderFns } from "./BaseFormDualInputList.vue?vue&type=template&id=25fc1eac"
import script from "./BaseFormDualInputList.vue?vue&type=script&lang=js"
export * from "./BaseFormDualInputList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports